import React from "react";

import "./Experience.css";
const Experience = () => {
  // const theme = useContext(themeContext);
  // const darkMode = theme.state.darkMode;

  return (
    <div className="experience" id='experienc'>
      <div className="achievement">
        {/* darkMode */}
        <div className="circle">2+</div>
        <span>years </span>
        <span>Experience</span>
      </div>
      <div className="achievement">
        <div className="circle">8+</div>
        <span>completed </span>
        <span>Projects</span>
      </div>
      <div className="achievement">
        <div className="circle">2+</div>
        <span>companies </span>
        <span>Work</span>
      </div>
    </div>
  );
};

export default Experience;